import { combineReducers } from 'redux';

const reducers = ['user', 'match', 'notify', 'page'];

export default combineReducers(
  reducers.reduce((initial, name) => {
    initial[name] = require(`./${name}`).default;
    return initial;
  }, {})
);
